import React from 'react';

const Blog = () => {
    return (
        <div className='bg-black' id='blog'>
            <h2 className='text-center py-12'>Blog is Coming soon ......</h2>
        </div>
    );
};

export default Blog;